var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96731 4.67188C6.96731 3.67949 6.18421 2.875 5.21821 2.875C4.25221 2.875 3.46912 3.67949 3.46912 4.67188C3.46912 5.66426 4.25221 6.46875 5.21821 6.46875C6.18421 6.46875 6.96731 5.66426 6.96731 4.67188Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6139 4.67188C13.6139 3.67949 12.8308 2.875 11.8648 2.875C10.8988 2.875 10.1157 3.67949 10.1157 4.67188C10.1157 5.66426 10.8988 6.46875 11.8648 6.46875C12.8308 6.46875 13.6139 5.66426 13.6139 4.67188Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2604 4.67188C20.2604 3.67949 19.4773 2.875 18.5113 2.875C17.5453 2.875 16.7622 3.67949 16.7622 4.67188C16.7622 5.66426 17.5453 6.46875 18.5113 6.46875C19.4773 6.46875 20.2604 5.66426 20.2604 4.67188Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96731 11.5C6.96731 10.5076 6.18421 9.70312 5.21821 9.70312C4.25221 9.70312 3.46912 10.5076 3.46912 11.5C3.46912 12.4924 4.25221 13.2969 5.21821 13.2969C6.18421 13.2969 6.96731 12.4924 6.96731 11.5Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6139 11.5C13.6139 10.5076 12.8308 9.70312 11.8648 9.70312C10.8988 9.70312 10.1157 10.5076 10.1157 11.5C10.1157 12.4924 10.8988 13.2969 11.8648 13.2969C12.8308 13.2969 13.6139 12.4924 13.6139 11.5Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2604 11.5C20.2604 10.5076 19.4773 9.70312 18.5113 9.70312C17.5453 9.70312 16.7622 10.5076 16.7622 11.5C16.7622 12.4924 17.5453 13.2969 18.5113 13.2969C19.4773 13.2969 20.2604 12.4924 20.2604 11.5Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96731 18.3281C6.96731 17.3357 6.18421 16.5312 5.21821 16.5312C4.25221 16.5312 3.46912 17.3357 3.46912 18.3281C3.46912 19.3205 4.25221 20.125 5.21821 20.125C6.18421 20.125 6.96731 19.3205 6.96731 18.3281Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6139 18.3281C13.6139 17.3357 12.8308 16.5312 11.8648 16.5312C10.8988 16.5312 10.1157 17.3357 10.1157 18.3281C10.1157 19.3205 10.8988 20.125 11.8648 20.125C12.8308 20.125 13.6139 19.3205 13.6139 18.3281Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2604 18.3281C20.2604 17.3357 19.4773 16.5312 18.5113 16.5312C17.5453 16.5312 16.7622 17.3357 16.7622 18.3281C16.7622 19.3205 17.5453 20.125 18.5113 20.125C19.4773 20.125 20.2604 19.3205 20.2604 18.3281Z",
    stroke: "black",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.ad62074955ff0ce6aa9f4f4e88599d3f.svg";
export { ForwardRef as ReactComponent };